import { useState } from "react";
import { useForgotPassword } from "../../login/hooks/useForgotPassword";

export default function ForgotPasswordForm() {
  const [email, setEmail] = useState("");
  const { sendResetLink, isLoading, message, error } = useForgotPassword();

  const handleSubmit = (e) => {
    e.preventDefault();
    sendResetLink(email);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div>
        <label className="text-sm font-semibold text-slate-600 dark:text-slate-300">
          Email Address
        </label>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full mt-2 p-3 rounded-xl border border-slate-300 dark:border-slate-600 dark:bg-slate-700"
          placeholder="Enter your registered email"
        />
      </div>

      {error && <p className="text-red-500 text-sm">{error}</p>}
      {message && <p className="text-green-500 text-sm">{message}</p>}

      <button
        type="submit"
        disabled={isLoading}
        className="w-full bg-[#1d57a5] text-white py-3 rounded-xl font-semibold hover:opacity-90 transition"
      >
        {isLoading ? "Sending..." : "Send Reset Link"}
      </button>
    </form>
  );
}
